import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CallbarComponent } from 'app/callbar/callbar/callbar.component';
import { CallDisplayComponent } from 'app/call-display/call-display/call-display.component';
import { CallDisplaySmartComponent } from 'app/call-display/call-display-smart/call-display-smart.component';
import { MatButtonModule } from '@angular/material/button';
import { QueueModule } from 'app/queue/queue.module';
import { MatGridListModule } from '@angular/material/grid-list';
import { MatMenuModule } from '@angular/material/menu';
import { MatDialogModule } from '@angular/material/dialog';
import { MatSelectModule } from '@angular/material/select';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatDividerModule } from '@angular/material/divider';
import { MatInputModule } from '@angular/material/input';
import { PhoneModule } from 'app/pipes/phone/phone-pipe.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AlertModule } from 'app/components/alert/alert.module';
import { SmsModule } from 'app/sms/sms.module';
import { NotesModule } from 'app/notes/notes.module';
import { SoftphoneMenuModule } from 'ng2-app/softphone-menu/softphone-menu.module';
import { MessagesModule } from 'app/messages/messages.module';
import { OnHoldCallComponent } from 'app/call-display/call-display/on-hold-call/on-hold-call.component';
import { MatIconModule } from '@angular/material/icon';
import { ScheduleReminderModule } from 'app/schedule-reminder/schedule-reminder.module';
import { SoftphoneTimerComponent } from 'app/call-display/call-display/softphone-timer/softphone-timer.component';
import { TruncateModule } from 'ng2-app/pipes/truncate/truncate-pipe.module';
import { MatListModule } from '@angular/material/list';
import { MatTableModule } from '@angular/material/table';
import { RouterModule } from '@angular/router';
import { AddNewLeadModule } from 'app/add-new-lead/add-new-lead.module';
import {
  MoveToExistingBusinessComponent
} from 'app/call-display/call-display/move-to-existing-business/move-to-existing-business.component';
import { BorrowerSearchInputModule } from 'app/borrower-search-input/borrower-search-input.module';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MidCallDispositionActionComponent } from 'app/call-display/call-display/mid-call-disposition-action/mid-call-disposition-action.component';

@NgModule( {
  imports: [
    AddNewLeadModule,
    AlertModule,
    BorrowerSearchInputModule,
    CommonModule,
    FormsModule,
    MatButtonModule,
    MatDialogModule,
    MatDividerModule,
    MatFormFieldModule,
    MatGridListModule,
    MatIconModule,
    MatInputModule,
    MatListModule,
    MatMenuModule,
    MatProgressSpinnerModule,
    MatSelectModule,
    MatTableModule,
    MatTooltipModule,
    MessagesModule,
    NotesModule,
    PhoneModule,
    PhoneModule,
    QueueModule,
    ReactiveFormsModule,
    RouterModule,
    ScheduleReminderModule,
    SmsModule,
    SoftphoneMenuModule,
    TruncateModule,
    MidCallDispositionActionComponent,
    MoveToExistingBusinessComponent,
  ],
  declarations: [
    CallDisplayComponent,
    CallDisplaySmartComponent,
    CallbarComponent,
    OnHoldCallComponent,
    SoftphoneTimerComponent,
  ],
  exports: [
    CallbarComponent,
  ]
} )
export class CallbarModule {
}
